import { useEffect, useRef, useState } from 'react';

const goodsImages = [
  {
    src: "https://irinomiyu-uuu.com/img/goods-Tokyo_b7fe86f0.jpg",
    alt: "グッズラインナップ - 東京ドームシティ kanadeviaホール",
    venue: "【東京ドームシティ kanadeviaホール】",
    venueMobile: ["【東京ドームシティ", "kanadeviaホール】"]
  },
  {
    src: "https://irinomiyu-uuu.com/img/goods-Osaka_k7R2pWn0.jpg",
    alt: "グッズラインナップ - Zepp Osaka Bayside",
    venue: "【Zepp Osaka Bayside】",
    venueMobile: null
  },
  {
    src: "https://irinomiyu-uuu.com/img/goods-Fukuoka_4d2e9a1b.jpg",
    alt: "グッズラインナップ - Zepp Fukuoka",
    venue: "【Zepp Fukuoka】",
    venueMobile: null
  }
];

interface GoodsProps {
  onImageClick: (imageUrl: string) => void;
}

export default function Goods({ onImageClick }: GoodsProps) {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="goods"
      className={`py-20 px-4 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#fcb122] px-8 md:px-12 py-3 md:py-4 shadow-[0_0_40px_#fcb122]">
            <h2 className="text-3xl md:text-5xl text-[#0a0a0a] font-bold">GOODS</h2>
          </div>
        </div>

        {/* グッズラインナップ */}
        <div className="mb-12 bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#fcb122]/50 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl text-[#fcb122] font-bold mb-6 text-center">
            グッズラインナップ
          </h3>
          {/* グッズ画像 2列 */}
          <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:[&>*:last-child:nth-child(odd)]:col-span-2 md:[&>*:last-child:nth-child(odd)]:max-w-[50%] md:[&>*:last-child:nth-child(odd)]:mx-auto">
            {goodsImages.map((image, index) => (
              <div key={index} className="flex flex-col items-center">
                <p className="text-sm md:text-base text-[#fcb122] text-center mb-3 font-bold">
                  {image.venueMobile ? (
                    <>
                      <span className="block md:hidden">
                        {image.venueMobile[0]}<br />{image.venueMobile[1]}
                      </span>
                      <span className="hidden md:block">{image.venue}</span>
                    </>
                  ) : (
                    image.venue
                  )}
                </p>
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-auto rounded-lg md:cursor-pointer md:hover:opacity-90 transition-opacity duration-300 md:hover:shadow-[0_0_20px_#fcb122]"
                  onClick={() => {
                    if (window.innerWidth >= 768) {
                      onImageClick(image.src);
                    }
                  }}
                />
              </div>
            ))}
          </div>

          {/* 公演共通 */}
          <div className="mb-8">
            <h3 className="text-base md:text-lg font-bold mb-4 text-[#1ef99d] border-b-2 border-[#1ef99d] pb-2">
              ＜公演共通＞
            </h3>
            <div className="space-y-3">
              <div>
                <div className="flex items-start gap-3">
                  <span className="text-xs md:text-sm">・コロミユぬいキー</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥3,000</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：全長約15cm</p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・使いやすいメッシュバック（ブラック・カーキ）全2種</span>
                  <span className="md:hidden text-xs">・使いやすいメッシュバック<br />（ブラック・カーキ）全2種</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">各¥3,500</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：高さ35cm/袋口幅43cm/底幅30cm</p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・ツアーT（ホワイト・ネイビー）全2種【M・L】</span>
                  <span className="md:hidden text-xs">・ツアーT<br />（ホワイト・ネイビー）全2種【M・L】</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">各¥4,000</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">
                  ※Mサイズ：身丈69cm/身幅52cm/肩幅46cm/袖丈20cm<br />
                  ※Lサイズ：身丈73cm/身幅55cm/肩幅50cm/袖丈22cm
                </p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・どこでもシールセット（5枚セット）全15種/ランダム</span>
                  <span className="md:hidden text-xs">・どこでもシールセット<br />（5枚セット）全15種/ランダム</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥800</span>
                </div>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・MOKU×UUUコラボタオル（ネイビー）</span>
                  <span className="md:hidden text-xs">・MOKU×UUUコラボタオル<br />（ネイビー）</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：33×100cm</p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="text-xs md:text-sm">・オシャレラグ</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥12,000</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：90×152cm（フリンジを除く）</p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・UUUスマートジャージ【M・L】</span>
                  <span className="md:hidden text-xs">・UUUスマートジャージ<br />【M・L】</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥13,000</span>
                  <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">
                  ※Ｍサイズ：身丈62cm 身幅58cm 裄丈83cm 裾巾50cm<br />
                  ※Ｌサイズ：身丈66cm 身幅62cm 裄丈84cm 裾巾54cm
                </p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・ブロマイドセット（４枚セット）A/B/C</span>
                  <span className="md:hidden text-xs">・ブロマイドセット<br />（４枚セット）A/B/C</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">各¥1,000</span>
                  <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：L判</p>
              </div>
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">・何が出るかな？お楽しみアイテム（アタリあり）全15種</span>
                  <span className="md:hidden text-xs">・何が出るかな？お楽しみアイテム<br />（アタリあり）全15種</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥500</span>
                  <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※アタリは入野自由のレア生写真！</p>
              </div>
            </div>
          </div>

          {/* 会場別カラーアイテム */}
          <div className="mb-8">
            <h3 className="text-base md:text-lg font-bold mb-4 text-[#fc457e] border-b-2 border-[#fc457e] pb-2">
              ＜会場別カラーアイテム＞
            </h3>
            <div className="space-y-4">
              {/* 東京公演 */}
              <div>
                <p className="text-xs md:text-sm font-bold text-[#1ef99d] mb-2">【4/13東京公演】</p>
                <div className="space-y-3 ml-2">
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・ミニポーチ（グリーン）</span>
                      <span className="md:hidden text-xs">・ミニポーチ<br />（グリーン）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：約W12.3×H10cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・巻きつけろ！オーロラバンド（グリーン）</span>
                      <span className="md:hidden text-xs">・巻きつけろ！オーロラバンド<br />（グリーン）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,200</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：W22×H2cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・MOKU×UUUコラボタオル（ライトグリーン）</span>
                      <span className="md:hidden text-xs">・MOKU×UUUコラボタオル<br />（ライトグリーン）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：33×100cm</p>
                  </div>
                </div>
              </div>
              {/* 大阪公演 */}
              <div>
                <p className="text-xs md:text-sm font-bold text-[#44c4ff] mb-2">【4/17大阪公演】</p>
                <div className="space-y-3 ml-2">
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・ミニポーチ（ブルー）</span>
                      <span className="md:hidden text-xs">・ミニポーチ<br />（ブルー）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：約W12.3×H10cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・巻きつけろ！オーロラバンド（ブルー）</span>
                      <span className="md:hidden text-xs">・巻きつけろ！オーロラバンド<br />（ブルー）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,200</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：W22×H2cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・MOKU×UUUコラボタオル（ミント）</span>
                      <span className="md:hidden text-xs">・MOKU×UUUコラボタオル<br />（ミント）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：33×100cm</p>
                  </div>
                </div>
              </div>
              {/* 福岡公演 */}
              <div>
                <p className="text-xs md:text-sm font-bold text-[#fc457e] mb-2">【5/1福岡公演】</p>
                <div className="space-y-3 ml-2">
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・ミニポーチ（レッド）</span>
                      <span className="md:hidden text-xs">・ミニポーチ<br />（レッド）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：約W12.3×H10cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・巻きつけろ！オーロラバンド（レッド）</span>
                      <span className="md:hidden text-xs">・巻きつけろ！オーロラバンド<br />（レッド）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,200</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：W22×H2cm</p>
                  </div>
                  <div>
                    <div className="flex items-start gap-3">
                      <span className="hidden md:inline text-xs md:text-sm">・MOKU×UUUコラボタオル（ピンク）</span>
                      <span className="md:hidden text-xs">・MOKU×UUUコラボタオル<br />（ピンク）</span>
                      <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">¥1,500</span>
                      <span className="text-[10px] md:text-xs text-[#fc457e] font-bold whitespace-nowrap">＊新商品</span>
                    </div>
                    <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※サイズ：33×100cm</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="bg-[#1a1a3e]/80 border-2 border-[#44c4ff]/50 px-6 py-4">
            <p className="text-xs md:text-sm text-white/70">
              ※お一人様1会計につき、「何が出るかな？お楽しみアイテム」はおひとり様1会計6点まで、その他の商品は各３点までの購入制限を設けさせていただきます。<br />
              ※表示価格はすべて消費税込です。<br />
              ※会場別カラーアイテムはデザイン共通で会場毎にカラーが異なります。<br />
              ※当日の状況により、購入上限数を変更する場合がございます。
            </p>
          </div>
        </div>

        {/* CD販売コーナー */}
        <div className="mb-12 bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#fcb122]/50 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl text-[#fcb122] font-bold mb-4 text-center">
            CD販売コーナー
          </h3>
          <p className="text-xs md:text-sm text-white/80 text-center mb-6 leading-relaxed">
            会場にて、最新シングル「驚きの子」、および「Who I Am」を販売いたします。<br />
            CD購入特典や、ツアー会場限定の抽選会も実施！<br />
            ぜひこの機会に、CD販売コーナーへお立ち寄りください！
          </p>
          {/* 横長画像2枚 */}
          <div className="space-y-4 mb-6">
            <img
              src="https://www.irinomiyu-uuu.com/img/special_y5N1jFm.jpg"
              alt="スペシャル情報"
              className="w-full h-auto rounded-lg md:cursor-pointer md:hover:opacity-90 transition-opacity duration-300 md:hover:shadow-[0_0_20px_#fcb122]"
              onClick={() => {
                if (window.innerWidth >= 768) {
                  onImageClick("https://www.irinomiyu-uuu.com/img/special_y5N1jFm.jpg");
                }
              }}
            />
            <img
              src="https://irinomiyu-uuu.com/img/lottery_f8c072e5.jpg"
              alt="抽選情報"
              className="w-full h-auto rounded-lg md:cursor-pointer md:hover:opacity-90 transition-opacity duration-300 md:hover:shadow-[0_0_20px_#fcb122]"
              onClick={() => {
                if (window.innerWidth >= 768) {
                  onImageClick("https://irinomiyu-uuu.com/img/lottery_f8c072e5.jpg");
                }
              }}
            />
          </div>

          {/* CD販売注意事項 */}
          <div className="bg-[#1a1a3e]/80 border-2 border-[#44c4ff]/50 px-6 py-4">
            <p className="text-xs md:text-sm text-white/70">
              ※商品・特典・景品には数に限りがございます。なくなり次第終了となりますので、予めご了承ください。<br />
              ※CDの在庫がなくなり次第、販売および抽選会・特典配布もすべて終了とさせて頂きます。<br />
              ※CDのご購入は、1会計につき合計5枚までの制限を設けさせて頂きます。<br />
              ※上記枚数以上の購入をご希望の方は、お手数ですが再度列の最後尾へお並び直しをお願いします。
            </p>
          </div>
        </div>

        {/* 会場販売について */}
        <div className="bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#1ef99d]/50 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl text-[#1ef99d] font-bold mb-6 text-center">
            会場販売について
          </h3>
          <div className="space-y-4">
            {/* 東京 */}
            <div>
              <p className="text-sm md:text-base text-white font-bold mb-1">
                <span className="block md:inline">4月13日(月)</span>
                <span className="block md:inline">東京ドームシティ<span className="block md:inline">kanadeviaホール</span></span>
              </p>
              <p className="text-xs md:text-sm text-white/80">
                ＜開場17:00 / 開演18:00＞
              </p>
            </div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex-1">
                <p className="text-xs md:text-sm text-[#1ef99d] font-bold mb-2">
                  《グッズ・CD販売時間》
                </p>
                <ul className="space-y-1 text-xs md:text-sm text-white/90">
                  <li>
                    <span className="block md:inline">13:00～16:00</span>
                    <span className="block md:inline">（チケットをお持ちでない方もご購入可能）</span>
                  </li>
                  <li>
                    <span className="block md:inline">開場後～終演後30分程度予定</span>
                    <span className="block md:inline">（当日のチケットをお持ちの方のみ）</span>
                  </li>
                </ul>
                <p className="text-xs md:text-sm text-white/70 mt-2">
                  ※16:00～開場時間までは、開場準備のため一時販売を中止いたします。
                </p>
              </div>
              <div className="flex justify-center items-center md:justify-end">
                <a
                  href="https://columbia.jp/irinomiyu-uuu/info.html#goods0413"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#44c4ff] text-[#0a0a0a] px-6 py-3 border-2 border-[#44c4ff] text-sm md:text-base hover:bg-[#1ef99d] hover:border-[#1ef99d] hover:text-[#0a0a0a] transition-all whitespace-nowrap font-bold shadow-[0_0_15px_#44c4ff] hover:shadow-[0_0_20px_#1ef99d] font-press-start cursor-pointer text-center"
                >
                  詳細はこちら <span className="font-dotgothic">▷</span>
                </a>
              </div>
            </div>
            {/* 大阪 */}
            <div className="border-t border-white/20 pt-4">
              <p className="text-sm md:text-base text-white font-bold mb-1">
                <span className="block md:inline">4月17日(金)</span>
                <span className="block md:inline">Zepp Osaka Bayside</span>
              </p>
              <p className="text-xs md:text-sm text-white/80">
                ＜開場17:00 / 開演18:00＞
              </p>
            </div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex-1">
                <p className="text-xs md:text-sm text-[#1ef99d] font-bold mb-2">
                  《グッズ・CD販売時間》
                </p>
                <ul className="space-y-1 text-xs md:text-sm text-white/90">
                  <li>
                    <span className="block md:inline">14:30～16:30</span>
                    <span className="block md:inline">（チケットをお持ちでない方もご購入可能）</span>
                  </li>
                  <li>
                    <span className="block md:inline">開場後～終演後30分程度予定</span>
                    <span className="block md:inline">（当日のチケットをお持ちの方のみ）</span>
                  </li>
                </ul>
                <p className="text-xs md:text-sm text-white/70 mt-2">
                  ※16:30～開場時間までは、開場準備のため一時販売を中止いたします。
                </p>
              </div>
              <div className="flex justify-center items-center md:justify-end">
                <a
                  href="https://columbia.jp/irinomiyu-uuu/info.html#goods0417"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#44c4ff] text-[#0a0a0a] px-6 py-3 border-2 border-[#44c4ff] text-sm md:text-base hover:bg-[#1ef99d] hover:border-[#1ef99d] hover:text-[#0a0a0a] transition-all whitespace-nowrap font-bold shadow-[0_0_15px_#44c4ff] hover:shadow-[0_0_20px_#1ef99d] font-press-start cursor-pointer text-center"
                >
                  詳細はこちら <span className="font-dotgothic">▷</span>
                </a>
              </div>
            </div>
            {/* 福岡 */}
            <div className="border-t border-white/20 pt-4">
              <p className="text-sm md:text-base text-white font-bold mb-1">
                <span className="block md:inline">5月1日(金)</span>
                <span className="block md:inline">Zepp Fukuoka</span>
              </p>
              <p className="text-xs md:text-sm text-white/80">
                ＜開場17:00 / 開演18:00＞
              </p>
            </div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex-1">
                <p className="text-xs md:text-sm text-[#1ef99d] font-bold mb-2">
                  《グッズ・CD販売時間》
                </p>
                <ul className="space-y-1 text-xs md:text-sm text-white/90">
                  <li>
                    <span className="block md:inline">14:00～16:30</span>
                    <span className="block md:inline">（チケットをお持ちでない方もご購入可能）</span>
                  </li>
                  <li>
                    <span className="block md:inline">開場後～終演後30分程度予定</span>
                    <span className="block md:inline">（当日のチケットをお持ちの方のみ）</span>
                  </li>
                </ul>
                <p className="text-xs md:text-sm text-white/70 mt-2">
                  ※16:30～開場時間までは、開場準備のため一時販売を中止いたします。<br />
                  ※当日、13:00頃より整列を開始いたします。近隣住民の方や近隣オフィスの皆様へのご迷惑とならないよう、<br />
                  13:00より前に会場付近に集まらないようご協力をお願いいたします。
                </p>
              </div>
              <div className="flex justify-center items-center md:justify-end">
                <a
                  href="https://columbia.jp/irinomiyu-uuu/info.html#goods0501"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#44c4ff] text-[#0a0a0a] px-6 py-3 border-2 border-[#44c4ff] text-sm md:text-base hover:bg-[#1ef99d] hover:border-[#1ef99d] hover:text-[#0a0a0a] transition-all whitespace-nowrap font-bold shadow-[0_0_15px_#44c4ff] hover:shadow-[0_0_20px_#1ef99d] font-press-start cursor-pointer text-center"
                >
                  詳細はこちら <span className="font-dotgothic">▷</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}